const UserProfileKeys = {
  StatusNotification: {
    DRIVER_NOTIFICATION_DEFAULT_CBP_MESSAGE: "statusNotification.driverNotificationDefaultCbpMessage"
  }
}

export default UserProfileKeys
